import { Button } from "@material-ui/core";
import React, { useEffect } from "react";
import "./Instruction.css";
import Img from "./meshimage.png";
const Instruction = (props) => {
  useEffect(() => {
    document.title = "Company core values creator | Mesh";
  }, []);
  return (
    <div className="instruction">
      <div className="instruction_image">
        <img style={{ width: "100%" }} src={Img} alt="mesh" />
      </div>
      <div className="instruction_data">
        <h2>
          The <b>quickest</b> and <b>easiest</b> way to create your core values
        </h2>
        <div style={{ fontWeight: "400", fontSize: "20px", color: "#696969" }}>
          <div>
            Creating core values can be a confusing and difficult process,
            that’s why we’ve made our <b>Core Value Creator</b> so easy to to
            use.
          </div>
          <br></br>
          <div>
            Using our emoji scale, just <b>slide</b> and <b>select</b> the
            response you feel best represents you and your company’s beliefs and
            smash the submit button at the bottom of the page.
          </div>
          <br></br>
          <div>
            Using our extensive values database comprising of over{" "}
            <b>150+ companies</b>, we’ll share 4 core values most suited for
            you!
          </div>
          <br></br>
          <div>Let’s get started!</div>
          <div>
            <Button
              style={{
                color: "white",
                backgroundColor: "#2ecc71",
                padding: "10px 30px",
                textTransform: "none",
                marginTop: "20px",
                marginBottom: "70px",
                borderRadius: "20px",
                fontFamily: "Montserrat",
              }}
              onClick={props.nextClicked}
            >
              Create your values
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Instruction;
